@if (count > 0) {
  <span class="unread-count-badge">{{ displayCount }}</span>
}
